import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ColDef, DoesFilterPassParams } from 'ag-grid-community';
import { CustomCellRendererProps } from 'ag-grid-react';
import { createDateCol } from '~/components/agGrid/columns/dateColumns';
import { CustomSetFilter } from '~/components/agGrid/filters/CustomSetFilter';
import { CdsLicenseFormValues } from './types';

export const cdsColumns = (): ColDef<CdsLicenseFormValues>[] => {
  return [
    {
      colId: 'validFlag',
      field: 'validFlag',
      maxWidth: 40,
      filter: false,
      sortable: false,
      headerName: '',
      cellRenderer: ({ data }: CustomCellRendererProps) => {
        if (data.validFlag) return null;
        return (
          <div className="flex justify-center h-full items-center">
            <ExclamationTriangleIcon className="h-5 w-5 text-warning mr-2" />
          </div>
        );
      },
    },
    {
      colId: 'issuingStateCode',
      field: 'issuingStateCode',
      valueGetter: ({ data }) => {
        if (data?.issuingStateCode) {
          return data.issuingStateCode.label;
        }
      },
      comparator: (valueA: string, valueB: string) => (valueA || '').localeCompare(valueB || ''),
      headerName: 'Issuing State',
    },
    {
      colId: 'issuingAgency',
      field: 'issuingAgency',
      headerName: 'Issuing Agency',
      wrapText: false,
      cellRenderer: ({ value }: CustomCellRendererProps<CdsLicenseFormValues, string>) => {
        const agency = value ?? '';
        return (
          <span className="block w-full truncate" title={agency}>
            {agency}
          </span>
        );
      },
    },
    {
      colId: 'licenseTitle',
      field: 'licenseTitle',
      headerName: 'Title',
      wrapText: false,
      cellRenderer: ({ value }: CustomCellRendererProps<CdsLicenseFormValues, string>) => {
        const title = value ?? '';
        return (
          <span className="block w-full truncate" title={title}>
            {title}
          </span>
        );
      },
    },
    {
      colId: 'licenseNum',
      field: 'licenseNum',
      headerName: 'Number',
    },
    createDateCol('issueDate', 'Issue Date'),
    createDateCol('expiryDate', 'Expiration Date'),
    {
      colId: 'status',
      headerName: 'Status',
      valueGetter: ({ data }) => (data?.activeFlag ? 'Active' : 'Inactive'),
      filter: {
        component: CustomSetFilter,
        doesFilterPass: ({ model, node }: DoesFilterPassParams) => {
          if (!model || model.length === 0) return true;
          const status = node.data?.activeFlag ? 'Active' : 'Inactive';
          return model.includes(status);
        },
      },
    },
  ];
};
